const API=`${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache=null;let _promise=null;

export const norm=(p)=>{
  let v=String(p||'').split('?')[0].split('#')[0];
  if(v.length>1)v=v.replace(/\/+$/,'');
  return v.toLowerCase();
};

export function getCache(){return _cache;}

export function loadRedirects(){
  if(_cache)return Promise.resolve(_cache);
  if(_promise)return _promise;
  _promise=fetch(`${API}/redirects`)
    .then(r=>r.ok?r.json():[])
    .then(d=>{_cache=Array.isArray(d)?d:[];return _cache;})
    .catch(()=>{_cache=[];return _cache;});
  return _promise;
}

export function matchRedirect(pathname){
  if(!_cache)return null;
  const here=norm(pathname);
  const hit=_cache.find(r=>norm(r.source)===here);
  if(!hit)return null;
  const dest=hit.destination||'';
  return norm(dest)===here?null:dest;
}
